var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellViewAllHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7C9.40666 7 8.82664 7.17595 8.33329 7.50559C7.83994 7.83523 7.45543 8.30377 7.22836 8.85195C7.0013 9.40013 6.94189 10.0033 7.05765 10.5853C7.1734 11.1672 7.45912 11.7018 7.87868 12.1213C8.29824 12.5409 8.83279 12.8266 9.41473 12.9424C9.99667 13.0581 10.5999 12.9987 11.1481 12.7716C11.6962 12.5446 12.1648 12.1601 12.4944 11.6667C12.8241 11.1734 13 10.5933 13 10C13 9.20435 12.6839 8.44129 12.1213 7.87868C11.5587 7.31607 10.7957 7 10 7Z",
    stroke: "#4B68CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7084 8C16.3792 6.89589 15.7794 5.87971 14.9499 5.05025C13.6372 3.7375 11.8567 3 10.0002 3C8.61573 3 7.26235 3.41054 6.11121 4.17971C4.96007 4.94888 4.06286 6.04213 3.53305 7.32121C3.44081 7.5439 3.36042 7.77047 3.29199 8M16.7084 12C16.5096 12.6669 16.2113 13.304 15.8205 13.889C15.0513 15.0401 13.9581 15.9373 12.679 16.4672C11.3999 16.997 9.99244 17.1356 8.63457 16.8655C7.2767 16.5954 6.02942 15.9287 5.05045 14.9497C4.22608 14.1254 3.62314 13.1107 3.29199 12",
    stroke: "#4B68CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellViewAllHover);
export default __webpack_public_path__ + "static/media/icn_table_cell_ViewAll_hover.39508a0c813fc1ae42da63301b03f834.svg";
export { ForwardRef as ReactComponent };